import { render } from "./ProcesosGraduacionConfiguracion.vue?vue&type=template&id=3804a8a2"
import script from "./ProcesosGraduacionConfiguracion.vue?vue&type=script&lang=js"
export * from "./ProcesosGraduacionConfiguracion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\GIT\\DevOps\\Planner\\FRONT_Planner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__